export const RubleRegular = ({
  customSymbol,
  p,
  fsize,
}: {
  customSymbol?: string;
  p?: number;
  fsize?: string;
}) => (
  <span
    style={{
      fontWeight: 400,
      fontSize: fsize || '16px',
      display: 'inline-block',
      padding: typeof p !== 'undefined' ? p : '0px 4px',
    }}
  >
    {customSymbol || '₽'}
  </span>
);
